"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = exports.Tip = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Box_1 = require("../Box");
var Popper_1 = require("../Popper");
var isTouch_1 = require("../lib/isTouch");
exports.Tip = (0, styled_components_1.default)(Box_1.Box).attrs({
    position: "relative",
    borderRadius: 4,
    fontSize: [2, 2, 1, 1],
    py: 2,
    px: 4,
    bg: "primary",
    color: "background",
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 1;\n"], ["\n  z-index: 1;\n"])));
var Mode;
(function (Mode) {
    Mode[Mode["Resting"] = 0] = "Resting";
    Mode[Mode["Active"] = 1] = "Active";
})(Mode || (Mode = {}));
var Tooltip = function (_a) {
    var label = _a.label, children = _a.children, placement = _a.placement, distance = _a.distance, _b = _a.forceForTouch, forceForTouch = _b === void 0 ? false : _b;
    var _c = __read((0, react_1.useState)(Mode.Resting), 2), mode = _c[0], setMode = _c[1];
    var handleMouseOver = (0, react_1.useCallback)(function () { return setMode(Mode.Active); }, []);
    var handleMouseOut = (0, react_1.useCallback)(function () { return setMode(Mode.Resting); }, []);
    var anchor = (0, react_1.useMemo)(function () {
        return react_1.default.cloneElement(children, {
            onMouseOver: handleMouseOver,
            onMouseOut: handleMouseOut,
        });
    }, [children, handleMouseOut, handleMouseOver]);
    var isOpen = mode === Mode.Active && !((0, isTouch_1.isTouch)() && !forceForTouch);
    return (react_1.default.createElement(Popper_1.Popper, { anchor: anchor, placement: placement, distance: distance, open: isOpen },
        react_1.default.createElement(exports.Tip, null, label)));
};
exports.Tooltip = Tooltip;
exports.Tooltip.displayName = "Tooltip";
var templateObject_1;
//# sourceMappingURL=Tooltip.js.map